import React, { useState, useCallback, useEffect } from "react";
import {
  FormLayout,
  TextField,
  Checkbox,
  Button,
  Text,
  Select,
  ButtonGroup,
  Popover,
  Icon,
  ActionList,
  Banner,
  RadioButton,
  Tooltip,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import { Editor } from "@tinymce/tinymce-react";
import {
  LanguageIcon,
  QuestionMarkMinor,
  MenuVerticalIcon,
  ColorsMajor,
  ListBulletedIcon,
} from "@shopify/polaris-icons";
import EditorTiny from "./EditorTiny";
import showTools from "../Assets/Images/show-tools.svg";
import hideTools from "../Assets/Images/hide-tools.svg";
import Instruction from "./Instruction";
import { accessEditSections } from "../Helpers";
import AsyncSelect from "react-select/async";
import { Stack } from "react-bootstrap";
import instructionImg from "../Assets/Images/instruction-help.svg";
import JoditEditorComponent from "./JoditEditor";

const RichTextSection = (props) => {
  const [boolRichTextTools, setBoolRichTextTools] = useState(false);
  const [data, setData] = useState([]);
  let object = JSON.parse(props.object);
  const { id } = useParams();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const handleChangeTitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaText = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaText: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLink = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeText = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLinkTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, ctaLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaTextTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, ctaText: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeTextTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChange = (newChecked) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, active: newChecked };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTemplate = (newValue) => {
    console.log("newValue=", newValue);
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, template: newValue };
      }
      return obj;
    });
    setData(newState);
  };
  useEffect(() => {
    !props.shopifyDomainFound &&
      setOptionsCtaLinkType(
        optionsCtaLinkType.filter(
          (item) =>
            item.label !== "Shopify Product" &&
            item.label !== "Shopify Collection"
        )
      );
    object = JSON.parse(props.object);
    setData(
      props.languagesArray
        .concat([{ label: "English", value: "en" }])
        .map((element, index) => {
          return {
            language: element.value,
            instruction: object?.instructions ? object?.instructions : "",
            title:
              object?.title && object?.title[element.value]
                ? object?.title[element.value]
                : "",
            ctaLinkType:
              object?.details?.cta_link_type !== null
                ? String(object?.details?.cta_link_type)
                : "",
            ctaText:
              object?.details?.cta_text &&
              object?.details?.cta_text[element.value]
                ? object?.details?.cta_text[element.value]
                : "",
            ctaLink:
              object?.details?.cta_link &&
              object?.details?.cta_link[element.value]
                ? object?.details?.cta_link[element.value]
                : "",
            ctaLinkPage: object?.details?.cta_page_alias
              ? object?.details?.cta_page_alias
              : "",
            ctaLinkBlog: object?.details?.cta_blog_alias
              ? object?.details?.cta_blog_alias
              : "",
            ctaLinkCollection: {
              label:
                object?.details && object?.details?.cta_shopify_collection_title
                  ? object?.details?.cta_shopify_collection_title
                  : "",
              value:
                object?.details && object?.details?.cta_shopify_collection_id
                  ? object?.details?.cta_shopify_collection_id
                  : "",
              handle:
                object?.details &&
                object?.details?.cta_shopify_collection_handle
                  ? object?.details?.cta_shopify_collection_handle
                  : "",
            },

            ctaLinkProduct: {
              label:
                object?.details && object?.details?.cta_shopify_product_title
                  ? object?.details?.cta_shopify_product_title
                  : "",
              value:
                object?.details && object?.details?.cta_shopify_product_id
                  ? object?.details?.cta_shopify_product_id
                  : "",
              handle:
                object?.details && object?.details?.cta_shopify_product_handle
                  ? object?.details?.cta_shopify_product_handle
                  : "",
            },
            text:
              object?.details?.text && object?.details?.text[element.value]
                ? object?.details?.text[element.value]
                : "",
            active: object?.details?.is_active ? true : false,
            template:
              object?.template_id !== null
                ? String(object?.template_id)
                : props.templates[0]?.id
                ? props.templates[0]?.id
                : "",
          };
        })
    );
  }, [props.object]);
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    []
  );
  const activator = (
    <Button onClick={togglePopoverActive} plain>
      <Icon source={MenuVerticalIcon} />
    </Button>
  );
  // useEffect(() => {
  //   const divEl = document.getElementById("container");

  //   divEl.addEventListener("dragstart", (event) => {
  //     event.preventDefault();
  //   });

  //   divEl.addEventListener("drop", (event) => {
  //     event.preventDefault();
  //   });
  // }, []);

  const handleSelectChangeCtaLinkType = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkType: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };

  const [optionsCtaLinkType, setOptionsCtaLinkType] = useState([
    { label: "External Link", value: "1" },
    { label: "Page", value: "2" },
    { label: "Blog", value: "3" },
    { label: "Shopify Product", value: "4" },
    { label: "Shopify Collection", value: "5" },
  ]);
  const [selectedPage, setSelectedPage] = useState("");
  const handleSelectChangePage = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkPage: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const handleSelectChangeBlog = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkBlog: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedShopifyCollection, setSelectedShopifyCollection] =
    useState("");
  const handleSelectChangeShopifyCollection = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkCollection: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedShopifyProduct, setSelectedShopifyProduct] = useState("");
  const handleSelectChangeShopifyProduct = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkProduct: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [
    firstTimeLoadedCollectionsOptions,
    setFirstTimeLoadedCollectionsOptions,
  ] = useState([]);
  const loadOptionsCollections = (inputValue, callback) => {
    axios
      .get(`/shopify-collections?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedCollectionsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };
  const [firstTimeLoadedProductsOptions, setFirstTimeLoadedProductsOptions] =
    useState([]);
  const loadOptionsProducts = (inputValue, callback) => {
    axios
      .get(`/shopify-products?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedProductsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };
  return (
    // <div className="no-click" onMouseDown={() => console.log("downn")}>
    <FormLayout>
      {/* <Instruction
        text={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").instruction
        }
        pageId={id}
        sectionId={props.sectionId}
        handleRefreshSections={props.handleRefreshSections}
      /> */}

      <div style={{ float: "right" }}>
        <ButtonGroup>
          <Button
            onClick={() => {
              setBoolRichTextTools(!boolRichTextTools);
            }}
            plain
          >
            <img src={boolRichTextTools ? showTools : hideTools} width={22} />
          </Button>
          <Button
            plain
            onClick={handleTranslate}
            icon={!translatedButtonClicked ? LanguageIcon : ""}
          >
            {translatedButtonClicked ? "Edit English" : "Translate"}
          </Button>
          {/* <Button
            plain
            onClick={() => props.handleCustomizeStyles()}
            icon={ColorsMajor}
          >
            Customize Styles
          </Button> */}
        </ButtonGroup>
      </div>
      <div style={{ overflow: "auto", minWidth: "100%" }}>
        <table>
          <tbody>
            <tr>
              <th>
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
              </th>
              <th>
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
              </th>
              {translatedButtonClicked && (
                <th>
                  {/* <Banner
                  title="Please select a language before you fill information"
                  status="info"
                  onDismiss={() => {}}
                ></Banner> */}
                  <Select
                    options={props.languagesArray}
                    onChange={handleSelectChangeLanguage}
                    value={selectedLanguage}
                    placeholder="Please select a language"
                  />
                </th>
              )}
            </tr>
            <tr>
              <td>
                <Text variant="bodyMd" as="p" color="subdued">
                  Title
                </Text>
              </td>
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").title
                  }
                  onChange={handleChangeTitle}
                  disabled={translatedButtonClicked}
                />
                {/* <EditorTiny
                boolRichTextTools={boolRichTextTools}
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").title
                }
                handleChangeValue={handleChangeTitle}
                disabled={translatedButtonClicked}
                height={100}
              /> */}
                {/* <Editor
                disabled={translatedButtonClicked}
                apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").title
                }
                init={{
                  branding: false,
                  height: 100,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                  ],
                  toolbar:
                    "undo redo | formatselect | bold italic backcolor | \
alignleft aligncenter alignright alignjustify | \
bullist numlist outdent indent | removeformat | help|code",
                }}
                onEditorChange={handleChangeTitle}
              /> */}
              </td>
              {translatedButtonClicked && (
                <td>
                  <TextField
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage).title
                    }
                    onChange={handleChangeTitleTranslated}
                  />
                  {/* <EditorTiny
                  boolRichTextTools={boolRichTextTools}
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).title
                  }
                  handleChangeValue={handleChangeTitleTranslated}
                  height={100}
                /> */}
                  {/* <Editor
                  apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).title
                  }
                  init={{
                    branding: false,
                    height: 100,
                    menubar: false,
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                    ],
                    toolbar:
                      "undo redo | formatselect | bold italic backcolor | \
alignleft aligncenter alignright alignjustify | \
bullist numlist outdent indent | removeformat | help|code",
                  }}
                  onEditorChange={handleChangeTitleTranslated}
                /> */}
                </td>
              )}
            </tr>

            <tr>
              <td>
                <Text variant="bodyMd" as="p" color="subdued">
                  CTA Text
                </Text>
              </td>
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").ctaText
                  }
                  onChange={handleChangeCtaText}
                  disabled={translatedButtonClicked}
                />
              </td>
              {translatedButtonClicked && (
                <td>
                  <TextField
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage).ctaText
                    }
                    onChange={handleChangeCtaTextTranslated}
                  />
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text variant="bodyMd" as="p" color="subdued">
                  CTA Link
                </Text>
              </td>

              <td className="rowDiv">
                <div style={{ width: "50%" }}>
                  <Select
                    options={optionsCtaLinkType}
                    onChange={handleSelectChangeCtaLinkType}
                    value={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").ctaLinkType
                    }
                    // value={selectedCtaLinkType}
                    placeholder="Please select"
                  />
                </div>
                <div style={{ width: "50%" }} className="ms-2">
                  {findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").ctaLinkType ===
                      "1" && (
                      <TextField
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").ctaLink
                        }
                        onChange={handleChangeCtaLink}
                        disabled={translatedButtonClicked}
                      />
                    )}
                  {findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").ctaLinkType ===
                      "4" && (
                      <AsyncSelect
                        cacheOptions
                        defaultOptions={firstTimeLoadedProductsOptions}
                        loadOptions={loadOptionsProducts}
                        onChange={handleSelectChangeShopifyProduct}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").ctaLinkProduct
                        }
                      />
                      // <Autocomplete
                      //   options={optionsCollections}
                      //   selected={selectedOptions}
                      //   onSelect={updateSelection}
                      //   textField={textField}
                      // />
                    )}
                  {findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").ctaLinkType ===
                      "5" && (
                      <AsyncSelect
                        cacheOptions
                        defaultOptions={firstTimeLoadedCollectionsOptions}
                        loadOptions={loadOptionsCollections}
                        onChange={handleSelectChangeShopifyCollection}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en")
                            .ctaLinkCollection
                        }
                        placeholder="Search"
                      />
                      // <Autocomplete
                      //   options={optionsCollections}
                      //   selected={selectedOptions}
                      //   onSelect={updateSelection}
                      //   textField={textField}
                      // />
                    )}

                  {findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").ctaLinkType ===
                      "2" && (
                      <Select
                        options={props.pagesArray}
                        onChange={handleSelectChangePage}
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").ctaLinkPage
                        }
                        placeholder="Please select"
                      />
                    )}
                  {findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").ctaLinkType ===
                      "3" && (
                      <Select
                        options={props.blogsArray}
                        onChange={handleSelectChangeBlog}
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").ctaLinkBlog
                        }
                        placeholder="Please select"
                      />
                    )}
                </div>
              </td>
              {translatedButtonClicked &&
                findArrayElementByLanguage(data, "en") &&
                findArrayElementByLanguage(data, "en").ctaLinkType === "1" && (
                  <td>
                    <TextField
                      value={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .ctaLink
                      }
                      onChange={handleChangeCtaLinkTranslated}
                    />
                  </td>
                )}
            </tr>
            {/* <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                CTA Link
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLink
                }
                onChange={handleChangeCtaLink}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).ctaLink
                  }
                  onChange={handleChangeCtaLinkTranslated}
                />
              </td>
            )}
          </tr> */}
            <tr>
              <td style={{ verticalAlign: "top" }}>
                <Text variant="bodyMd" as="p" color="subdued">
                  Text
                </Text>
              </td>
              <td style={{ verticalAlign: "top" }}>
                <JoditEditorComponent
                  boolRichTextTools={boolRichTextTools}
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").text
                  }
                  handleChangeValue={handleChangeText}
                  disabled={translatedButtonClicked}
                  height={200}
                />
              </td>
              {translatedButtonClicked && (
                <td style={{ verticalAlign: "top" }}>
                  <JoditEditorComponent
                    boolRichTextTools={boolRichTextTools}
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage).text
                    }
                    handleChangeValue={handleChangeTextTranslated}
                    height={200}
                  />
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>

      {/* <InlineStack gap="200" align="start" blockAlign="center">
        <RadioButton
          label="Accounts are disabled"
          helpText="Customers will only be able to check out as guests."
          // checked={value === "disabled"}
          id="disabled"
          name="accounts"
          // onChange={handleChange}
        />
        <RadioButton
          label="Accounts are optional"
          helpText="Customers will be able to check out with a customer account or as a guest."
          id="optional"
          name="accounts"
          // checked={value === "optional"}
          // onChange={handleChange}
        />
      </InlineStack> */}
      <Text>Template: </Text>
      <div className="boxTemplates">
        {props.templates?.length ? (
          props.templates.map((item, index) => {
            return (
              <div
                style={{ marginRight: "1rem" }}
                key={item.id}
                onClick={() => handleChangeTemplate(item.id)}
                className={`divTemplate ${
                  findArrayElementByLanguage(data, "en")
                    ? String(
                        findArrayElementByLanguage(data, "en").template
                      ) === String(item.id) && "borderTemplate"
                    : ""
                }`}
              >
                {item.text && (
                  <div className="templateInstruction">
                    <Tooltip content={item.text}>
                      <img
                        src={instructionImg}
                        width={17}
                        className="templateInstruction"
                      />
                    </Tooltip>
                  </div>
                )}

                <div className="buttonTemplate">
                  {item.image && <img src={item.image} width={30}></img>}
                  <div style={{ marginTop: "0.2rem" }}>
                    <Text color="subdued">{item.description}</Text>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <Text color="subdued">No templates added for this section type</Text>
        )}
      </div>

      {/* <Select
        label="Template"
        options={props.templates
          .map((item, index) => {
            return {
              key: String(item.id),
              label: item.description,
              value: String(item.id),
            };
          })
          .concat([{ label: "None", value: "none" }])}
        onChange={handleChangeTemplate}
        value={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").template
        }
        placeholder="Please select"
      /> */}
      <Checkbox
        label="Is Active"
        checked={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").active
        }
        onChange={handleChange}
      />
      <FormLayout.Group>
        {/* <Button
          primary
          onClick={() => {
            props.handleSavingState();
            axios
              .delete(`/pages/${id}/sections/${props.sectionId}`)
              .then((result) => {
                props.handleDeleteAndRefresh();
              })
              .catch((err) => console.log(err));
          }}
          loading={props.isSaving}
          destructive
          fullWidth
        >
          Delete
        </Button> */}
        <div style={{ float: "right" }}>
          <Button
            prim
            variant="primary"
            ary
            onClick={handleSave}
            loading={props.isSaving}
            disabled={!accessEditSections()}
          >
            Save
          </Button>
        </div>
      </FormLayout.Group>
    </FormLayout>
    // </div>
  );
  function handleSave() {
    props.handleSavingState();
    const form_data = new FormData();
    findArrayElementByLanguage(data, "en") &&
      (findArrayElementByLanguage(data, "en").template === "none"
        ? form_data.append(`template_id`, "")
        : form_data.append(
            `template_id`,
            findArrayElementByLanguage(data, "en").template
          ));
    console.log(
      "tessst=",
      findArrayElementByLanguage(data, "en").ctaLinkType !== undefined
    );
    findArrayElementByLanguage(data, "en") &&
      String(findArrayElementByLanguage(data, "en").ctaLinkType) !==
        "undefined" &&
      form_data.append(
        `cta_link_type`,
        findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").ctaLinkType
      );
    findArrayElementByLanguage(data, "en") &&
      findArrayElementByLanguage(data, "en").ctaLinkPage !== null &&
      form_data.append(
        `cta_page_alias`,
        findArrayElementByLanguage(data, "en").ctaLinkPage
      );
    findArrayElementByLanguage(data, "en") &&
      findArrayElementByLanguage(data, "en").ctaLinkBlog !== null &&
      form_data.append(
        `cta_blog_alias`,
        findArrayElementByLanguage(data, "en").ctaLinkBlog
      );
    findArrayElementByLanguage(data, "en") &&
      findArrayElementByLanguage(data, "en").ctaLinkCollection &&
      form_data.append(
        `cta_shopify_collection_id`,
        findArrayElementByLanguage(data, "en").ctaLinkCollection.value
      );
    findArrayElementByLanguage(data, "en") &&
      findArrayElementByLanguage(data, "en").ctaLinkProduct &&
      form_data.append(
        `cta_shopify_product_id`,
        findArrayElementByLanguage(data, "en").ctaLinkProduct.value
      );
    findArrayElementByLanguage(data, "en") &&
      findArrayElementByLanguage(data, "en").ctaLinkCollection &&
      form_data.append(
        `cta_shopify_collection_title`,
        findArrayElementByLanguage(data, "en").ctaLinkCollection.label
      );
    findArrayElementByLanguage(data, "en") &&
      findArrayElementByLanguage(data, "en").ctaLinkProduct &&
      form_data.append(
        `cta_shopify_product_title`,
        findArrayElementByLanguage(data, "en").ctaLinkProduct.label
      );
    findArrayElementByLanguage(data, "en") &&
      findArrayElementByLanguage(data, "en").ctaLinkCollection &&
      form_data.append(
        `cta_shopify_collection_handle`,
        findArrayElementByLanguage(data, "en").ctaLinkCollection.handle
      );
    findArrayElementByLanguage(data, "en") &&
      findArrayElementByLanguage(data, "en").ctaLinkProduct &&
      form_data.append(
        `cta_shopify_product_handle`,
        findArrayElementByLanguage(data, "en").ctaLinkProduct.handle
      );
    data.forEach((selected, index) =>
      form_data.append(`title[${selected.language}]`, selected.title)
    );
    data.forEach((selected, index) =>
      // selected.ctaText &&
      form_data.append(`cta_text[${selected.language}]`, selected.ctaText)
    );
    data.forEach((selected, index) =>
      form_data.append(`text[${selected.language}]`, selected.text)
    );
    data.forEach(
      (selected, index) =>
        selected.ctaLink &&
        form_data.append(`cta_link[${selected.language}]`, selected.ctaLink)
    );
    form_data.append("is_active", data[data.length - 1].active ? 1 : 0);
    props.selectedChannels && props.selectedChannels.length
      ? props.selectedChannels.forEach((selected, index) =>
          form_data.append(`channels[${index}]`, selected)
        )
      : form_data.append(`channels`, []);
    form_data.append("_method", "PATCH");

    axios
      .post(`/pages/${id}/sections/${props.sectionId}`, form_data)
      .then((res) => {
        props.handleSaveAndRefresh();
      })
      .catch((err) => console.log(""));
  }
  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
};
export default RichTextSection;
